<template>
    <div>
        <div v-if="$route.path.indexOf('_editor') === -1">
            <el-row :gutter="20">
                <el-col :span="3">
                    <el-button type="primary" icon="plus" @click="descTemplate" style="width: 100%" size="mini">导出详细报表</el-button>
                </el-col>
               <el-col :span="3">
                    <el-button type="primary" icon="plus" @click="countTemplate" style="width: 100%" size="mini">导出统计报表</el-button>
                </el-col>
            </el-row>
            
               
            <el-row :gutter="20">
                <el-col :md="10" :lg="7">
                    <el-input placeholder="直播标题" size="small" v-model="params.title"><el-button slot="append" icon="el-icon-search" @click="search"></el-button></el-input>
                </el-col>
                <el-col :md="10" :lg="5">
                    <el-select size="small" v-model="params.cate_name" clearable placeholder="请选择直播分类" @change="search">
                        <el-option v-for="item in category" :key="item.value" :label="item.cate_name" size="mini" :value="item.cate_name"> </el-option>
                    </el-select>
                </el-col>
                 <el-col :md="10" :lg="8">
                    <el-date-picker v-model="upload_at" type="daterange" start-placeholder="开始时间" ange-separator="至" end-placeholder="结束时间" value-format="yyyy/MM/dd" placeholder="选择日期范围" style="width: 100%;" @change="updateDateChange" size="mini"></el-date-picker>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="17">
                    <section class="section-card realtime-statics" v-loading="userloading">
                        <div class="section-card-header">
                            <div class="section-card-title">
                                实时概况
                            </div>
                            <div class="header-small">
                                更新时间：{{Date.now()/1000 | datetime('yyyy-MM-dd hh:mm:ss')}}
                            </div>
                            <!-- <ul class="header-filters">
                                <li class="filter-item">全店</li>
                                <li class="filter-item">网店</li>
                                <li class="filter-item">所有门店</li>
                            </ul> -->
                        </div>
                        <div>
                            <el-row class="analysis" :gutter="20">
                                <el-col :span="12">
                                    <div class="view-flex">
                                        <div class="view-flex-item">
                                            <div class="label">红包(元)</div>
                                            <div class="real-data">{{SumMoney}}</div>
                                        </div>
                                        <div class="view-flex-item">
                                            <div class="label">优惠券</div>
                                            <div class="real-data">{{SumCoupon}}</div>
                                            
                                        </div>
                                        <div class="view-flex-item">
                                            <div class="label">积分</div>
                                            <div class="real-data">{{SumIntegral}}</div>
                                            
                                        </div>
                                        <div class="view-flex-item">
                                            <div class="label">人数</div>
                                            <div class="real-data">{{SumPeople}}</div>
                                            
                                        </div>
                                    </div>
                                </el-col>
                                
                            </el-row>
                            
                        </div>
                    </section>
                </el-col>
            </el-row>
            <el-tabs v-model="activeName" type="border-card">
                <el-tab-pane v-for="(item, index) in tabList" :key="index" :label="item.name" :name="item.activeName">
                    <el-table :data="ItemsList" style="width: 100%" @selection-change="handleSelectionChange"  v-loading="loading">
                        
                        <el-table-column  width="70"></el-table-column>
                        <el-table-column prop="live_id" label="直播ID" width="150"></el-table-column>
                        
                        <el-table-column prop="cate_name" label="分类" width="120" show-overflow-tooltip >
                            <template slot-scope="scope" style="white-space: nowrap">{{scope.row.cate_name}}</template>
                        </el-table-column>
                        <el-table-column prop="anchor_name" label="主播" width="120" >
                            
                        </el-table-column>
                        
                        <el-table-column prop="title" label="直播标题" width="230" ></el-table-column>
                       
                        <el-table-column prop="is_record" label="是否录播" width="90" v-if="false">
                            <!--<template slot-scope="scope">-->
                            <!--<el-tag size="mini" effect="plain" type="success" v-for="(v,k) in isRecordOption" :key="index" v-if="scope.row.is_record==v.value">{{v.title}}</el-tag>-->
                            <!--</template>-->
                            <template slot-scope="scope">
                                <el-switch v-model="scope.row.is_record"  active-value="1" inactive-value="0" active-color="#13ce66"  inactive-color="#ff4949" @change="switchRecord(scope.$index, scope.row)"></el-switch>
                            </template>
                        </el-table-column>
                        <el-table-column prop="coupon" label="优惠券" width="100">
                            <template slot-scope="scope" style="white-space: nowrap">{{scope.row.coupon}}张</template>
                        </el-table-column>
                        <el-table-column prop="integral" label="积分" width="100">
                            <template slot-scope="scope" style="white-space: nowrap">{{scope.row.integral}}个积分</template>
                        </el-table-column>
                        <el-table-column prop="money" label="红包" width="100">
                            <template slot-scope="scope" style="white-space: nowrap">{{scope.row.money}}RMB</template>
                        </el-table-column>
                        
                        
                    </el-table>
                    <div class="content-center content-top-padded">
                        <el-pagination
                                background
                                layout="total, sizes, prev, pager, next"
                                @current-change="handleCurrentChange"
                                @size-change="handleSizeChange"
                                :current-page.sync="params.page"
                                :page-sizes="[10,20,50]"
                                :total="total_count"
                                :page-size="params.pageSize">
                        </el-pagination>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
       
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import { getDistributorList } from '../../api/marketing'
    import {
        getLiveReceive as getList,
        updateLiveStatus as updateStatus,
        deleteLive as deleteItem,
        getLiveGoods as getLiveGoods,
        deleteLiveGoods as deleteLiveGoods,
        getAnchorList as getAnchorList,
        getPushUrl as getPushUrl,
        getLiveConf,
        BatchDeleteLive,
        getCateList,
        getLiveLog,
        getLiveOperationLog,
        getLiveExport,
        getMarkingLogExport,
        getCountLogExport,
    } from '../../api/live'
    import sideBar from '@/components/element/sideBar'
    export default {
        components: {
          sideBar
        },
        props: {
          distributorId: {
            type: String,
            default: ''
          },
          isLoad: {
            type: Boolean,
            default: false
          }
        },
        data () {
            return {
                userloading: true,
                status:'',
                SumMoney:0,
                SumCoupon:0,
                SumIntegral:0,
                SumPeople:0,
                loading:true,
                exportloading: false,
                tabList: [
                    {name: "列表", value: null, activeName: 'first'},
                    // {name: "已领取完列表", value: 'true', activeName: 'second'},
                ],
                activeName: 'first',
                ItemsList: [],
                params: {
                    page: 1,
                    pageSize: 20,
                    live_id:'',
                    anchor_id:'',
                    anchor_name:'',
                    inca_id:'',
                    title:'',
                    description:'',
                    cover_image:'',
                    item_bn:'',
                    is_record:'',
                    source_video_type:'',
                    source_video_url:'',
                    start_at:'',
                    end_at:'',
                    start_upload_at:'',
                    end_upload_at:'',
                    cate_name:''
                },
                start_at:'',
                end_at:'',
                upload_at:'',
                total_count:0,
                isRecordOption: [
                    { title: '允许', value: '1' },
                    { title: '不允许', value: '0' },
                ],
                cate_name:'',
                sourceVideoTypeOption:[],
                category:[],
                distributorList:[],
                rowData:[],
                item_id:[],
                show_sideBar: false,
                show_edit: false
            }
        },
        computed: {
            ...mapGetters([
                'wheight'
            ])
        },
        methods: {
            exportData (index, item) {
                this.exportloading = true
                this.params.export = 1
                this.params.live_id = item
                // console.log(this.params);
                getLiveExport(this.params).then(res => {
                    this.exportloading = false
                    if (res.data.status) {
                        this.$message({
                            type: 'success',
                            message: '已加入执行队列，请在设置-导出列表中下载'
                        })
                        return
                    }else {
                        this.$message({
                            type: 'error',
                            message: '无内容可导出 或 执行失败，请检查重试'
                        })
                        return
                    }
                }).catch( error => {
                    this.exportloading = false
                })
            },
            handleCurrentChange (page_num) {
                this.params.page = page_num
                this.getList()
            },
            selectCount(index, row)
            {
                this.show_sideBar = true
                getLiveLog({live_id:row.live_id}).then(res => {
                    this.liveLog = res.data.data.list
                })
            },
            descTemplate()
            {
                getMarkingLogExport(this.params).then(res => {
                    this.exportloading = false
                    if (res.data.status) {
                        this.$message({
                            type: 'success',
                            message: '已加入执行队列，请在设置-导出列表中下载'
                        })
                        return
                    }else {
                        this.$message({
                            type: 'error',
                            message: '无内容可导出 或 执行失败，请检查重试'
                        })
                        return
                    }
                }).catch( error => {
                    this.exportloading = false
                })
            },
            countTemplate()
            {
                getCountLogExport(this.params).then(res => {
                    this.exportloading = false
                    if (res.data.status) {
                        this.$message({
                            type: 'success',
                            message: '已加入执行队列，请在设置-导出列表中下载'
                        })
                        return
                    }else {
                        this.$message({
                            type: 'error',
                            message: '无内容可导出 或 执行失败，请检查重试'
                        })
                        return
                    }
                }).catch( error => {
                    this.exportloading = false
                })
            },
            editCount(index, row)
            {
                this.show_edit = true
                getLiveOperationLog({live_id:row.live_id}).then(res => {
                    console.log(res.data);
                    this.LiveOperationLog = res.data.data.list
                })
            },
            handleSizeChange (pageSize) {
                this.params.page = 1
                this.params.pageSize = pageSize
                this.getList()
            },
            handleSelectionChange (val) {
                let item_id = []
                for (let i in val) {
                    item_id.push(val[i].live_id)
                }
                this.item_id = item_id
            },
            batchDelete(){
                this.$confirm('此操作将批量删除数据,删除后不可恢复， 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    BatchDeleteLive({id:this.item_id}).then(res=>{
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 2 * 1000
                        })
                        this.search();
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    })
                })

            },
            handleGoodsDialogCurrentChange (page_num) {
                this.params.page = page_num
                this.getList()
            },
            handleGoodsDialogSizeChange (pageSize) {
                this.params.page = 1
                this.params.pageSize = pageSize
                this.getList()
            },
            async handleDialogGoods(row,live_id) {
                this.goodsList = [];
                this.rowData = row;
                this.goodsDialog.goodsTitle = '(id:'+row.live_id + ')' + row.anchor.nickname + "-" + row.distributor.name ;
                this.goodsDialog.dialogLoading = true
                this.goodsDialog.goodsVisible = true
                this.goodsDialog.goodsParams.page = 1
                this.goodsDialog.goodsParams.pageSize = 10
                await getLiveGoods({'id':live_id}).then(res=>{
                    if(res.data.data){
                        this.goodsDialog.dialogLoading = false
                        this.goodsList = res.data.data;
                        console.log(this.goodsList)
                    }
                });

            },
            handleGoodsDialogCancel(){
                this.goodsDialog.goodsVisible = false
            },
            switchRecord(index, row) {
                let params = {
                    'id': row.live_id,
                    'is_record': row.is_record ,
                }
                updateStatus(params).then(res => {
                    if (res.data.data.status) {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 2 * 1000
                        })
                        //this.getList()
                    }
                })
            },
            dateChange (val) {
                if (val && val.length > 0) {
                    this.params.start_at = this.dateStrToTimeStamp(val[0] + ' 00:00:00')
                    this.params.end_at = this.dateStrToTimeStamp(val[1] + ' 23:59:59')
                } else {
                    this.params.start_at = ''
                    this.params.end_at = ''
                }
                this.search();
            },
            updateDateChange (val) {
                if (val && val.length > 0) {
                    this.params.start_upload_at = this.dateStrToTimeStamp(val[0] + ' 00:00:00')
                    this.params.end_upload_at = this.dateStrToTimeStamp(val[1] + ' 23:59:59')
                } else {
                    this.params.start_upload_at = ''
                    this.params.end_upload_at = ''
                }
                this.search();
            },
            dateStrToTimeStamp (str) {
                return Date.parse(new Date(str))/1000
            },
            addItems () { // 添加
                this.$router.push({path: this.matchHidePage('editor')})
            },

            editItemsAction (index, row, isNew) { // 编辑弹框
                if (isNew) {
                    var routeData = this.$router.push({ path: this.matchHidePage('editor/') + row.live_id, query: { is_new: true}});
                } else {
                    var routeData = this.$router.push({ path: this.matchHidePage('editor/') + row.live_id});
                }
            },
            search () {
                this.params.page = 1
                this.getList()
            },
            getList () {
                this.userloading = true
                this.loading = true
                getList(this.params).then(response => {
                    this.ItemsList = response.data.data.list
                    this.total_count = response.data.data.total_count
                    this.SumMoney = response.data.data.sum_money?response.data.data.sum_money:0
                    this.SumCoupon = response.data.data.sum_coupon?response.data.data.sum_coupon:0
                    this.SumIntegral = response.data.data.sum_integral?response.data.data.sum_integral:0
                    this.SumPeople = response.data.data.sum_people?response.data.data.sum_people:0
                    this.warning_store = response.data.data.warning_store
                    this.loading = false
                    this.userloading = false
                })
            },
            deleteItemsAction (index, row) {
                this.$confirm('此操作将删除该条数据, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteItem(row.live_id).then(response => {
                        this.ItemsList.splice(index, 1)
                        this.$message({
                            message: '删除成功',
                            type: 'success',
                            duration: 2 * 1000
                        })
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    })
                })
            },
            deleteGoodsAction (index, row) {
                this.$confirm('此操作将删除该条数据, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteLiveGoods({goods_id:row.item_id,live_id:this.rowData.live_id}).then(response => {
                        this.ItemsList.splice(index, 1)
                        this.$message({
                            message: '删除成功',
                            type: 'success',
                            duration: 2 * 1000
                        })
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    })
                })
            },
            updateItemStatus (items,status) {
                this.loading = true
                let params = {}
                params = {
                    'id': items.anchor_id,
                    'status': status,
                }
                updateStatus(params).then(res => {
                    if (res.data.data.status) {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 2 * 1000
                        })
                        this.getList()
                    }
                })
                this.loading = false
            },
            getDistributorList(val){
                getDistributorList({page: 1, pageSize: 50,name:val}).then(res => {
                    this.distributorList = [{name:'请选择店铺',id:''}];
                    for (let item of res.data.data.list) {
                        this.distributorList.push({name: item.name, id: item.number})
                    }
                    // console.log( this.distributorList);
                })
            },
            handleDistibutorChange:function (val){
                this.params.inca_id = val
                this.getList()
            },
            getAnchorList(val){
                getAnchorList({page: 1, pageSize: 50,nickname:val}).then(res => {
                    this.anchorList = [{name:'请选择主播',id:''}];
                    for (let item of res.data.data.list) {
                        this.anchorList.push({name: item.nickname, id: item.anchor_id})
                    }
                })
            },
            handleAnchorChange:function (val){
                this.params.anchor_id = val
                this.getList()
            },
            handleGetPushUrl(row){
                let params = {
                    'id': row.anchor_id,
                    'live_id':row.live_id,
                }
                getPushUrl(params).then(res => {
                    if (res.data) {
                        const h = this.$createElement;
                        this.$message({
                            message: h('p', null, [
                                h('span', null, '推流地址： '),
                                h('p', { style: 'color: blue;padding-right:25px;' }, res.data.data.push_url)
                            ]),
                            showClose: true,
                            duration: 10 * 1000,
                        });
                    }
                })
            },

        },
        mounted () {
            getLiveConf().then(res=>{

                if(res.data){
                    this.sourceVideoTypeOption = res.data.source_video_type
                }
            })
            
            getCateList({page:1,pageSize:-1}).then(res=>{
                if(res.data){
                    this.category = res.data.data.list
                }
            })
            this.params = this.$route.query
            this.getList()
            this.getDistributorList()
            this.getAnchorList()
        },
        watch: {
            getStatus (val) {
                if (val) {
                    this.getList()
                }
            },
            $route(){
                this.getList()
            }
        }
    }

</script>
<style>
    .goods-popover-img{
        margin-top: 5px;
        margin-bottom: 5px;
        background:#000;
        border:1px solid #fff;
        border-width:5px 5px 5px 5px;
        box-shadow:1px 1px 5px #333;
        -webkit-box-shadow:1px 1px 5px #333;
        -moz-box-shadow:1px 1px 5px #333;
    }
</style>
<style scoped lang="scss">
    .main {
        min-width: 1024px;
    }
    .unbind-box {
        display: flex;
        align-items: center;
        justify-content: center;
    height: 285px;
        .iconfont {
            display: block;
            margin-bottom: 20px;
            font-size: 70px;
            line-height: 1;
            color: #eaeaea;
        }
    p {
      margin-bottom: 20px;
    }
  }

    .section-card {
        padding: 30px;
        background: #fff;
        box-shadow: 0 0 10px rgba(0,0,0,0.1);
        &.realtime-statics {
            height: 138px;
        }
        &.chart-statics {
            height: 318px;
        }
        .section-card-header {
            display: flex;
            align-items: flex-end;
            padding-bottom: 20px;
            .section-card-title {
                margin-right: 20px;
                font-size: 16px;
                font-weight: 600;
            }
            .header-small {
                flex: 1;
                font-size: 12px;
                color: #ccc;
            }
            .header-filters {
                display: flex;
                .filter-item {
                    position: relative;
                    padding: 0 15px;
                    color: #999;
                    font-size: 12px;
                    &::after {
                        position: absolute;
                        left: 0;
                        top: 20%;
                        bottom: 20%;
                        width: 1px;
                        background: #efefef;
                        content: "";
                    }
                    &:first-child::after {
                        content: none;
                    }
                }
            }
        }
    }

    .company {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 285px;
        .logo {
            margin-bottom: 20px;
            width: 70px;
            height: 70px;
            border-radius: 100%;
        }
        .name {
            margin-bottom: 10px;
            font-size: 14px;
        }
        .operate {
            padding-bottom: 50px;
        }
        .validity-period {
            display: flex;
            font-size: 12px;
            color: #999;
            .iconfont {
                margin-right: 10px;
                font-size: 12px;
            }
        }
    }

    .analysis {
        padding-left: 20px;
        padding-top: 10px;
        .label {
            font-size: 12px;
            color: #999;
        }
        .real-data {
            font-size: 20px;
            font-family: "Helvetica Neue";
            font-weight: 500;
        }
        .history-data {
            font-size: 12px;
            color: #ccc;
        }
    }

    .notices {
        padding-left: 20px;
        .notices-group {
            padding: 10px 0;
        }
        .subtitle {
            padding-bottom: 10px;
            font-size: 14px;
            color: #666;
        }
        .notice-item {
            font-size: 12px;
            color: #999;
            cursor:pointer;
        }
    }

    .quick-link {
        padding-left: 20px;
        .link-item {
            float: left;
            width: 230px;
            margin: 10px 0;
            color: #666;
            cursor:pointer;
            .iconfont {
                display: inline-block;
                margin-right: 10px;
                width: 25px;
                height: 25px;
                line-height: 25px;
                text-align: center;
                border-radius: 5px;
                color: #fff;
                font-size: 12px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// receive.vue?d96fe8b2